import { render, staticRenderFns } from "./KeystrokeInputableText.vue?vue&type=template&id=0fb5481c&"
import script from "./KeystrokeInputableText.ts?vue&type=script&lang=ts&"
export * from "./KeystrokeInputableText.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports